import {
  TotpStatus,
  TUser,
  TUserRoles,
  TUserStatus,
  UserStatus,
} from '@/features/users/schemas/users.schema.ts';

export const statuses = UserStatus.map((status) => ({
  label: status,
  value: status,
}));

export const getLabelStatus = (userStatus: TUserStatus) => {
  if (userStatus === 'Active') {
    return 'green';
  }
  if (userStatus === 'Pending Verification') {
    return 'yellow';
  }
  if (userStatus === 'Suspended') {
    return 'red';
  }
  if (userStatus === 'Rejected') {
    return 'red';
  }
  if (userStatus === 'Deactivated') {
    return 'gray';
  }
  if (userStatus === 'Locked') {
    return 'purple';
  }
  if (userStatus === 'Archived') {
    return 'blue';
  }
  if (userStatus === 'Pending Approval') {
    return 'indigo';
  }
  if (userStatus === 'Expired') {
    return 'pink';
  }
  if (userStatus === 'Maintenance') {
    return 'yellow';
  }
  return 'green';
};

export const getLabelRole = (userRole: string) => {
  if (userRole === 'Company owner') {
    return 'pink';
  }
  if (userRole === 'Company administrator') {
    return 'purple';
  }
  if (userRole === 'Manufacturer') {
    return 'green';
  }
  if (userRole === 'Installer') {
    return 'blue';
  }
  if (userRole === 'Owner') {
    return 'yellow';
  }
  if (userRole === 'Guest') {
    return 'gray';
  }
  return 'gray';
};

export function getCompactUserRole(role: TUserRoles, isMobile: boolean) {
  if (!isMobile) return role;
  const words = role.split(' ');
  if (words.length <= 1) return role;
  return `${words[0][0].toUpperCase()} ${words.slice(1).join(' ')}`;
}

export function getTotpStatusBadgeVariant(status: (typeof TotpStatus)[number]) {
  switch (status) {
    case 'Enabled':
      return 'green';
    case 'Pending Setup':
      return 'yellow';
    case 'Suspended':
      return 'red';
    case 'Recovery Mode':
      return 'purple';
    case 'Disabled':
      return 'gray';
    default:
      return 'gray';
  }
}

export function isUserEligibleForAssignment(user: Pick<TUser, 'role' | 'status'>): boolean {
  return user.role !== 'Unknown' && user.status === 'Active';
}
